"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rxjsOperators = exports.instance = void 0;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var typedi_1 = require("typedi");
var SeismicCommonCore_1 = require("./SeismicCommonCore");
var instance;
exports.instance = instance;
try {
    var instance_1 = typedi_1.Container.get('instance');
    if (instance_1) {
        throw new Error('An instance already exists. Please confirm that you are not including frontend-services(formerly seismic-common) twice');
    }
}
catch (ex) {
    exports.instance = instance = new SeismicCommonCore_1.SeismicCommonCore();
    typedi_1.Container.set('instance', instance);
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
__exportStar(require("./entrypoint"), exports);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var SeismicCommon = __importStar(require("./entrypoint"));
if (window.__seismicCommonInstance__) {
    throw new Error('There is already a seismic common instance. Please make sure you are not including the seismic-common package more than once. You can use a webpack external pointing to window.SeismicCommon. If you are using the seismic-webpack-build-plugin, please be sure to use the latest version');
}
// Seismic web app has an "interesting" system for loading modules.
// It expects a common JS module but ignores the exports. We have to manually set the globals.
// TODO: window.__seismicCommonInstance__ should be removed. Any code relying on it can use window.SeismicCommon.instance
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.__seismicCommonInstance__ = instance;
window.SeismicCommon = SeismicCommon;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.BrowserServices = __assign(__assign({}, SeismicCommon), { instance: instance });
exports.rxjsOperators = __importStar(require("rxjs/operators"));
//# sourceMappingURL=index.js.map